import { useQuery } from '@apollo/client';
import { WELCOME_DONE_STATS_QUERY } from '../../graphql/queries';
import { useWelcomeContext } from './WelcomeContext';

/**
 * Live counts + profile slug for Done-screen variants. Skipped in the admin
 * preview modal (there's no real session to summarize — it would reflect the
 * signed-in admin).
 */
export function useDoneStats() {
  const { isPreview } = useWelcomeContext();
  const { data, loading } = useQuery(WELCOME_DONE_STATS_QUERY, {
    skip: isPreview,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });

  const profileSlug: string | null = data?.profile?.slug ?? null;
  // In the admin preview there's no real slug, but variants still render the
  // profile CTA (pointing at the Town Square root) so the admin sees the
  // complete screen. Real users get their actual profile URL.
  let profileUrl: string | null = null;
  if (profileSlug) {
    profileUrl = `${__TOWN_SQUARE_URL__}/${profileSlug}`;
  } else if (isPreview) {
    profileUrl = __TOWN_SQUARE_URL__;
  }

  return {
    uploaded: (data?.imageStats?.count ?? 0) as number,
    following: (data?.profile?.followingCount ?? 0) as number,
    communities: (data?.myCommunities?.length ?? 0) as number,
    profileSlug,
    communityUrl: `${__TOWN_SQUARE_URL__}/community`,
    profileUrl,
    loading,
  };
}
